import axios from 'axios'
import {Message} from 'element-ui'

// 创建axios实例
const httpService = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // 请求超时时间
    timeout: 5000 // 需自定义
})

// request拦截器
/*httpService.interceptors.request.use(
  config => {
    // 根据条件加入token-安全携带
    if (true) { // 需自定义
      // 让每个请求携带token
      config.headers['User-Token'] = ''
    }
    return config
  },
  error => {
    // 请求错误处理
    Promise.reject(error)
  }
)*/
const err = (error) => {
    if (error.response) {
        let data = error.response.data
        // const token = Vue.ls.get(ACCESS_TOKEN)
        //console.log('------异常响应------', token)
        console.log('------异常响应------', error.response.status)
        switch (error.response.status) {
            case 403:
                Message.error({message: '拒绝访问'})
                break
            case 500:
                Message.error({message: '很抱歉，登录已过期，请重新登录'})
                break
            case 404:
                Message.error({message: '很抱歉，资源未找到!'})
                break
            case 504:
                Message.error({message: '网络超时'})
                break
            case 401:
                Message.error({message: '未授权，请重新登录'})
                break
            default:
                Message.error({message: data.message})
                break
        }
    }
    return Promise.reject(error)
}


httpService.interceptors.response.use((response) => {
    return response.data
}, err)

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function getAction(url, parameter) {
    return httpService({
        url: url,
        method: 'get',
        params: parameter
    })
}

/*
 *  delete请求
 *  url:请求地址
 *  params:参数
 * */
export function deleteAction(url, parameter) {
    return httpService({
        url: url,
        method: 'delete',
        params: parameter
    })
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function postAction(url, parameter) {
    return httpService({
        url: url,
        method: 'post',
        data: parameter
    })
}

/*
 *  put请求
 *  url:请求地址
 *  params:参数
 * */
export function putAction(url, parameter) {
    return httpService({
        url: url,
        method: 'put',
        data: parameter
    })
}

/**
 * 下载文件
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url,parameter){
    return httpService({
        url: url,
        params: parameter,
        method:'get' ,
        responseType: 'blob'
    })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
    return downFile(url, parameter).then((data) => {
        if (!data || data.size === 0) {
            Vue.prototype['$message'].warning('文件下载失败')
            return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data]), fileName)
        } else {
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) //下载完成移除元素
            window.URL.revokeObjectURL(url) //释放掉blob对象
        }
    })
}

